
<div class = "dispatch-button">
    <a @click.stop="onPlus" v-if="plusActive">
        <v-icon
            :color = "user && hasEntriesWithoutUser ? 'success' : 'secondary'"
            class  = "toolbar-button"
            size   = "20"
        >
            mdi-account-plus
        </v-icon>
    </a>

    <a @click.stop="onMinus" v-if="minusActive" >
        <v-icon
            :color = "hasEntriesWithUser ? 'red' : 'secondary'"
            class  = "toolbar-button"
            size   = "20"
        >
            mdi-account-minus
        </v-icon>
    </a>
</div>
